import axios from 'axios';
import authHeader from "@/service/auth-header";

class AuditTrailService {

    async getCompanyAuditTrails(companyId) {
        return await axios.get(`/api/audittrail/company/${companyId}`, {headers: authHeader()})
    }

    async getCompanyAuditTrailsLastTwenty(companyId) {
        return await axios.get(`/api/audittrail/last20/company/${companyId}`, {headers: authHeader()})
    }

    async getCompanyAuditTrailsLimitedByCount(companyId, entries) {
        return await axios.get(`/api/audittrail/company/${companyId}/${entries}`, {headers: authHeader()})
    }

    async createAuditTrail(data) {
        return await axios.post(`/api/audittrail`, data, {headers: authHeader()});
    }


}

export default new AuditTrailService();
